<!--How to use-->
<!--<Popup :name="'popup-name'" :cancel-text="'Cancel'" :submit-text="'Submit'" @onSubmit="onSubmit">-->
<!--  <template slot="header">Place your header in here</template>-->
<!--  <template slot="body">Place your body in here</template>-->
<!--</Popup>-->

<template>
  <modal :name="name" class="popup-modal" :width="700">
    <div class="modal-header">
      <div class="modal-header-text">
        <span>
          <slot name="header">Header</slot>
        </span>
      </div>
    </div>
    <div class="modal-body">
      <a>
        <span class="modal-body-text">
          <slot name="body">Body</slot>
        </span>
        <br/>
      </a>
    </div>
    <div class="modal-footer">
      <b-button class="modal-btn-left ap-btn secondary" @click="hideModal()">
        {{ cancelText || 'Cancel' }}
      </b-button>
      <b-button class="modal-btn-right ap-btn primary" @click="btnAction()">
        {{ submitText || 'Submit' }}
      </b-button>
    </div>
  </modal>
</template>

<script>
export default {
  props: [
    'name',
    'cancelText',
    'submitText'
  ],
  data () {
    return {
      cancelText: this.cancelText,
      okText: this.okText
    }
  },
  methods: {
    async hideModal () {
      await this.$emit('onCancel');
      this.$modal.hide(this.name);
    },
    async btnAction () {
      await this.$emit('onSubmit');
      this.$modal.hide(this.name);
    }
  },
  computed: {

  }
}
</script>

<style scoped lang="less">
@import '../../styles/variables.less';

.popup-modal {
  &.modal-change-order-detail {
    .v--modal-box {
      overflow-y: scroll;
    }
  }
  margin: 0;
  background: rgba(0, 0, 0, 0.4);

  .modal-header {
    padding: 0;
    border: 0;
    width: 85%;
    margin: 0 auto;

    .line{
      box-sizing: border-box;
      height: 3px;
      width: 593px;
      border: 1px solid #E6E6E6;
    }
    .modal-header-text {
      margin-top: 50px;
      // width: auto;
      color: @black;
      font-family: @font-family-title;
      font-size: 24px;
      font-weight: bold;
      line-height: 29px;
      text-transform: none;
    }
    .modal-header-change-order-text{
      margin-top: 25px;
      margin-left: 25px;
      height: 29px;
      width: auto;
      color: @black;
      font-family: @font-family-title;
      font-size: 24px;
      font-weight: bold;
      line-height: 29px;
    }
    .modal-header-line{
      box-sizing: border-box;
      height: 3px;
      width: 593px;
      border: 1px solid @grey-4;
    }
  }
  .modal-body {
    height: auto;
    width: 85%;
    margin: 0 auto;
    padding: 20px 0 0 0;

    .modal-body-text {
      color: #424242;
      font-family: @font-family-main;
      font-size: 16px;
      line-height: 24px;
    }
    .modal-body-text-li {
      margin-top: 20px;
    }
  }
  .modal-body-changeOrderDetail{
    .modal-body-changeOrderDetail-text{
      margin-top: 25px;
      margin-left: 25px;
      color: @black;
      font-family: @font-family-main;
      font-size: 14px;
      line-height: 14px;
    }
    .modal-body-changeOrderDetail-event-detail{
      margin: 26px 0 0 0;
    }
  }
  .modal-footer {
    position: absolute;
    bottom: 0;
    right: 0;
    padding: 0;
    float: right;
    border: 0;
    .modal-btn-left {
      border-radius: 4px;
      margin-left: 15px;
      margin-bottom: 50px;
      margin-top: 30px;
      text-transform: none;

      .modal-btn-left-text {
        color: @light-blue;
        font-family: @font-family-main;
        font-size: 12px;
        font-weight: 600;
        line-height: 17px;
      }
    }
    .modal-btn-right {
      border-radius: 4px;
      margin-right: 50px;
      margin-bottom: 50px;
      margin-top: 30px;
      text-transform: none;

      .modal-btn-right-text {
        color: @white;
        font-family: @font-family-main;
        font-size: 12px;
        font-weight: 600;
        line-height: 17px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Popup.vue?b7af85bc